import { useI18n } from "@/i18n";
import { Link } from "react-router-dom";
import { Mark, Wordmark } from "@/components/ax/Mark";
import { betaRelease } from "../components/ax/BetaNotice";

const Section = ({ id, title, children }) => (
  <section id={id} className="mt-10">
    <h2 className="text-lg font-semibold">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-6 text-ax-text-2">{children}</div>
  </section>
);

export default function Kebijakan() {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-ax-bg px-4 py-8 text-ax-text">
      <main className="mx-auto w-full max-w-[720px]" data-testid="kebijakan-page">
        <Link to="/masuk" aria-label="AXORIS" className="inline-flex items-center gap-3 text-ax-brand">
          <Mark size={24} />
          <Wordmark />
        </Link>
        <h1 className="type-h1 mt-8">{t("policy.page.title")}</h1>
        <p className="mt-2 text-sm text-ax-muted">{t("policy.page.dates")}</p>
        <p className="mt-4 text-sm">
          <a href="mailto:halo@axoris.id" data-testid="support-email" className="text-ax-link hover:underline">
            halo@axoris.id
          </a>
        </p>

        <Section id="privasi" title={t("policy.page.privacy")}>
          <p>{t("policy.page.account")}</p>
          <p>{t("policy.page.consent")}</p>
          <p>{t("policy.page.stored")}</p>
          <p>{t("policy.page.export")}</p>
          <p>{t(betaRelease ? "beta.deleteUnavailable" : "policy.page.delete")}</p>
          <p>{t("policy.page.access")}</p>
        </Section>

        <Section id="syarat" title={t("policy.page.terms")}>
          <p>{t("policy.page.decision")}</p>
          <p>{t("policy.page.library")}</p>
          <p>{t("policy.page.price")}</p>
        </Section>

        <Section id="dpa" title={t("policy.page.processing")}>
          <p>{t("policy.page.providers")}</p>
          <p>{t("policy.page.payment")}</p>
        </Section>
      </main>
    </div>
  );
}
